import { Navigate, useLocation, useParams } from 'react-router-dom';

export default function LegacyAnalysesRedirect() {
  const { projectId } = useParams();
  const location = useLocation();

  return (
    <Navigate
      replace
      to={{
        pathname: `/projects/${projectId}/datacenter/analyses`,
        search: location.search,
        hash: location.hash,
      }}
      state={location.state}
    />
  );
}
